//Generated File 
export default class PrintingOption{
	static readonly DIALOG = `DIALOG`;
	static readonly DIRECT = `DIRECT`;
	static readonly NONE = `NONE`;
}
